import React from 'react';
import PropTypes from 'prop-types';
import variables from '../variables';

const RoundCheckIcon = ({
  height = 40,
  color = variables.colors.darkerTextGrey,
  accentColor = variables.colors.white,
  ...props
}) => {
  return (
    <svg
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="20" height="20" rx="10" fill={color} />
      <path
        d="M13.6611 8.61621L8.95272 13.9132L6.0841 11.0446"
        stroke={accentColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

RoundCheckIcon.propTypes = {
  height: PropTypes.number,
  color: PropTypes.string,
  accentColor: PropTypes.string,
};

export default RoundCheckIcon;
